if (!customElements.get('ro-quick-add-modal')) {
  customElements.define(
    'ro-quick-add-modal',
    class RoQuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);

        const productHandle = opener.dataset.productHandle;

        fetch(window.Shopify.routes.root + `products/${productHandle}/` + `?sections=ro-quick-add-content`)
          .then(res => res.json())
          .then(data => {

            // The HTML of the section 'ro-quick-add-content'
            const quickAddContent = data['ro-quick-add-content'];

            // Insert the HTML into the modal content
            if (this.modalContent) {
              this.modalContent.innerHTML = quickAddContent; 

              super.show(opener);

            } else {
              console.error('Modal content element not found.');
            }
          })
          .catch(error => {
            console.error('Error fetching section (ro-quick-add-content):', error);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
